import { FC } from 'react'
import { Link } from 'react-router-dom'

import * as S from './styled'
import {
  ArcPlusIcon,
  ChatIcon,
  CheckBadgeIcon,
  CoinPrimaryIcon,
  CursorIcon,
  DatabaseLayersIcon,
  GiftIcon,
  HeadsetIcon,
  LinkIcon,
  LocationIcon,
  LockIcon,
  MegaphoneIcon,
  MicrophoneIcon,
  NetworkNodesIcon,
  PlusCircleIcon,
  SendArrowIcon,
  TicketRoundIcon,
  ToolEadIcon,
  ToolWrenchIcon,
  UserIcon
} from '../../icons'
import TicketPrimaryIcon from '../../icons/TicketPrimaryIcon'
import FileIcon from '../../icons/FileIcon'

const OptIn: FC = () => (
  <S.Container>
    <S.Wrapper>
      <S.Title>
        <span>03</span> Adesão e benefícios por categoria
      </S.Title>

      <S.Content>
        <S.Step1>
          <img
            src={`${window.env.assetHost}assets/images/lmcv/program-rules/acesse-plataforma-programa-fidelidade.png`}
            alt="Acesse a plataforma do Programa de Fidelidade"
          />
          <S.InnerTop>
            <S.Bullet>
              <strong>1</strong>
            </S.Bullet>

            <h3>Acesse a plataforma do Programa de Fidelidade</h3>

            <Link to="/fidelidade/como-funciona" target="_blank">
              <S.InnerTopLink>Clique aqui</S.InnerTopLink>
            </Link>
          </S.InnerTop>
        </S.Step1>

        <S.Step2>
          <img
            src={`${window.env.assetHost}assets/images/lmcv/program-rules/preencha-cadastro-aceite-termos.png`}
            alt="Preencha o cadastro e aceite os Termos e Condições"
          />

          <S.InnerTop>
            <S.Bullet>
              <strong>2</strong>
            </S.Bullet>
            <h3>
              Preencha o cadastro e aceite
              <br />
              os Termos e Condições
            </h3>
            <p>
              O Participante é responsável pelos seus dados e declara que as
              informações fornecidas são completas, verdadeiras, atuais e
              precisas.
            </p>
          </S.InnerTop>
        </S.Step2>
      </S.Content>
      <S.Step3>
        <S.Bullet>
          <strong>3</strong>
        </S.Bullet>
        <p>
          Verifique o critério de adesão e os benefícios para cada categoria:
        </p>
      </S.Step3>

      <S.RowTop>
        <S.ColumnTop1>
          <UserIcon />
          <h3>Cliente</h3>
        </S.ColumnTop1>
        <S.ColumnTop2>
          <S.RowTop2>
            <CursorIcon />
          </S.RowTop2>
          Através do site{' '}
          <S.Link>
            <Link to="/fidelidade/como-funciona" target="_blank">
              www.leroymerlin.com.br/fidelidade/como-funciona
            </Link>
          </S.Link>
        </S.ColumnTop2>
        <S.ColumnTop3>
          <S.RowTop2>
            <ChatIcon />
          </S.RowTop2>
          Aceite ao convite das áreas de Espaço Serviço das Lojas Físicas, com a
          validação no link enviado por e-mail ou SMS ao Cliente.
        </S.ColumnTop3>
      </S.RowTop>

      <S.SubTitle>Benefícios</S.SubTitle>

      <S.HighLights>
        <S.Item>
          <S.Circle>
            <GiftIcon color="#78BE20" />
          </S.Circle>
          Acúmulo de pontos;
        </S.Item>

        <S.Item>
          <S.Circle>
            <CoinPrimaryIcon />
          </S.Circle>
          Resgate de cashback na LEROY MERLIN;
        </S.Item>

        <S.Item>
          <S.Circle>
            <LockIcon />
          </S.Circle>
          Cupom de desconto de boas-vindas;
        </S.Item>

        <S.Item>
          <S.Circle>
            <TicketPrimaryIcon />
          </S.Circle>
          Cupom de desconto no mês de aniversário;
        </S.Item>

        <S.Item>
          <S.Circle>
            <ToolWrenchIcon />
          </S.Circle>
          Cupom de desconto em produtos e seções;
        </S.Item>
      </S.HighLights>

      <S.Notice>
        <h3>Outros</h3>

        <p>
          O envio automático e gratuito de conteúdo como vídeos, textos, guias e
          manuais; promoção de ofertas relâmpagos em pontos de venda; pontos em
          dobro para produtos ou forma de pagamento;
        </p>
      </S.Notice>

      <S.RowTop>
        <S.ColumnTop6>
          <ToolEadIcon />
          <h3>EAD</h3>
        </S.ColumnTop6>
        <S.ColumnTop4>
          <S.RowTop2>
            <SendArrowIcon />
          </S.RowTop2>
          Através do envio de documentação do registro perante o órgão de
          classe, no site ou no aplicativo do Programa de Fidelidade.
        </S.ColumnTop4>
        <S.ColumnTop5>
          <S.RowTop2>
            <FileIcon />
          </S.RowTop2>
          Os documentos que comprovem as profissões (CAU, CREA e ABD) serão
          analisados pela LEROY MERLIN em até 10 dias úteis.
        </S.ColumnTop5>
      </S.RowTop>

      <S.RowDouble>
        <S.RowItem>
          <S.RowTop2>
            <CheckBadgeIcon />
          </S.RowTop2>
          Com a aprovação, os profissionais poderão aproveitar os benefícios
          exclusivos, que podem estar relacionados ou não à profissão.
        </S.RowItem>
        <S.RowItemAlert>
          <MegaphoneIcon />

          <p>
            O profissional que não enviar a documentação não poderá usufruir dos
            benefícios do módulo EAD, ficando desta forma elegível apenas aos
            benefícios do módulo cliente.
          </p>
        </S.RowItemAlert>
      </S.RowDouble>

      <S.SubTitle>Benefícios</S.SubTitle>

      <S.HighLights>
        <S.Item>
          <S.Circle>
            <NetworkNodesIcon />
          </S.Circle>
          Acúmulo de 10% dos pontos gerados por seus clientes vinculados no
          Programa (para Engenheiros e Decoradores), além dos pontos por suas
          próprias compras;
        </S.Item>

        <S.Item>
          <S.Circle>
            <PlusCircleIcon />
          </S.Circle>
          Pontuação Extra em atividades especiais criadas à critério da LEROY
          MERLIN;
        </S.Item>

        <S.Item>
          <S.Circle>
            <DatabaseLayersIcon />
          </S.Circle>
          Resgate de cashback em pontos na LEROY MERLIN;
        </S.Item>
      </S.HighLights>

      <S.HighLights>
        <S.Item>
          <S.Circle>
            <LinkIcon />
          </S.Circle>
          Desconto em produtos selecionados para profissionais da área da
          construção;
        </S.Item>

        <S.Item>
          <S.Circle>
            <TicketRoundIcon />
          </S.Circle>
          Cupom de Desconto;
        </S.Item>
      </S.HighLights>

      <S.Notice>
        <h3>Outros</h3>

        <p>
          O envio automático e gratuito de conteúdo direcionado, como vídeos,
          textos, guias e manuais; promoção de ofertas relâmpagos em pontos de
          venda e pontos em dobro para algum produto ou forma de pagamento.
        </p>
      </S.Notice>

      <S.RowTop>
        <S.ColumnTop1>
          <LocationIcon />
          <h3>
            <ArcPlusIcon width={154} height={56} />
          </h3>
        </S.ColumnTop1>
        <S.ColumnTop2>
          <S.RowTop2>
            <S.Number>1</S.Number>
          </S.RowTop2>
          Após o cadastro, é necessária aprovação da documentação (CAU,
          inscrição municipal e comprovante bancário),{' '}
          <strong>no prazo médio de 7 dias úteis.</strong>
        </S.ColumnTop2>
        <S.ColumnTop3>
          <S.RowTop2>
            <S.Number>2</S.Number>
          </S.RowTop2>
          Depois, o arquiteto poderá:
          <ul>
            <li>convidar seus clientes para estarem vinculados à sua conta;</li>
            <li>
              cadastrar os projetos de seus clientes e, se desejar, enviar a
              documentação de sua empresa (CNPJ) para participar do segmento
              ARC+.
            </li>
          </ul>
        </S.ColumnTop3>
      </S.RowTop>

      <S.RowTop>
        <S.ColumnTop7>
          <S.RowTop2>
            <S.Number>3</S.Number>
          </S.RowTop2>
          Seus Clientes receberão um e-mail ou um link através do whatsapp para
          a aprovação do vínculo,{' '}
          <strong>que tem duração de três meses e pode ser renovado.</strong>
        </S.ColumnTop7>
        <S.ColumnTop7>
          <S.RowTop2>
            <S.Number>4</S.Number>
          </S.RowTop2>
          A aprovação deve ocorrer antes da compra, como meio de computar a
          pontuação ocasionada pelas compras dos clientes.
        </S.ColumnTop7>
      </S.RowTop>

      <S.SubTitle>Benefícios</S.SubTitle>

      <S.HighLights>
        <S.Item>
          <S.Circle>
            <GiftIcon color="#78BE20" />
          </S.Circle>
          Acúmulo de 100% dos pontos decorrentes de compras realizadas por seu
          cliente, além do acúmulo de pontos por suas próprias compras;
        </S.Item>

        <S.Item>
          <S.Circle>
            <CoinPrimaryIcon />
          </S.Circle>
          O cashback será de 5% do total de pontos disponíveis no momento do
          resgate e pode ser solicitado conforme a disponibilidade de resgate;
        </S.Item>

        <S.Item>
          <S.Circle>
            <HeadsetIcon />
          </S.Circle>
          Outros benefícios, como o atendimento nas lojas e promoções;
        </S.Item>
      </S.HighLights>

      <S.RowTop>
        <S.ColumnTop1>
          <MicrophoneIcon />
          <h3>Executor/PRO</h3>
        </S.ColumnTop1>
        <S.ColumnTop4>
          <S.RowTop2>
            <S.Number>1</S.Number>
          </S.RowTop2>
          Após o cadastro, o profissional deve ir até uma loja da LEROY MERLIN e
          confirmar o interesse em ser um Executor/ PRO
        </S.ColumnTop4>
        <S.ColumnTop4>
          <S.RowTop2>
            <S.Number>2</S.Number>
          </S.RowTop2>
          Para a aprovação do cadastro, será verificado na loja se o cliente é
          apto a se enquadrar nessa modalidade.
        </S.ColumnTop4>
      </S.RowTop>

      <S.RowTop>
        <S.ColumnTop7>
          <S.RowTop2>
            <S.Number>3</S.Number>
          </S.RowTop2>
          Após a seleção pelos colaboradores, os participantes farão parte do
          Executor/ PRO, com o recebimento de benefícios exclusivos.
        </S.ColumnTop7>
        <S.ColumnTop7>
          <S.RowTop2>
            <S.Number>4</S.Number>
          </S.RowTop2>
          A partir da seleção, os participantes do Executor/ PRO deixarão de
          receber o acúmulo de pontos, sendo aplicáveis os benefícios descritos
          aqui.
        </S.ColumnTop7>
      </S.RowTop>

      <S.SubTitle>Benefícios</S.SubTitle>

      <S.HighLights>
        <S.Item>
          <S.Circle>
            <GiftIcon color="#78BE20" />
          </S.Circle>
          Cashback Mensal
          <br />
          Valor de cashback não cumulativo creditado mensalmente na conta do
          Programa de Fidelidade do participante Executor/ PRO, de acordo com os
          critérios de elegibilidade estabelecidos;
        </S.Item>

        <S.Item>
          <S.Circle>
            <LinkIcon />
          </S.Circle>
          Desconto em produtos selecionados para profissionais da área da
          construção;
        </S.Item>

        <S.Item style={{ width: 300 }}>
          <S.Circle>
            <LockIcon />
          </S.Circle>
          Cupom de Desconto;
        </S.Item>
      </S.HighLights>

      <S.Notice style={{ marginBottom: 50 }}>
        <h3>Outros</h3>
        <p>
          O envio automático e gratuito de conteúdo direcionado, como vídeos,
          textos, guias e manuais e promoção de ofertas relâmpagos em pontos de
          venda.
        </p>
      </S.Notice>

      <S.RowText>
        <S.ColumnText>
          <p>
            São disponibilizados descontos recorrentes exclusivos que podem ser
            disponibilizados na plataforma do Programa de Fidelidade.
          </p>

          <p>
            Para usar, realize a identificação da compra com o CPF na LEROY
            MERLIN
          </p>
        </S.ColumnText>
        <S.ColumnTextAlert>
          <MegaphoneIcon />
          <div>
            <h3>Atenção</h3>
            <p>
              Cada participante pode criar apenas uma conta. A LEROY MERLIN
              poderá suspender ou cancelar contas em duplicidade.
            </p>
          </div>
        </S.ColumnTextAlert>
      </S.RowText>

      <S.RowTextBottom>
        <h3>Regras de convivência entre Programas de Fidelidade</h3>
        <p>
          Cada um dos Participantes poderá aderir apenas a uma das categorias do
          Programa de Fidelidade.
        </p>

        <h3>Mudança de programa</h3>

        <p>
          A mudança do programa poderá ser solicitada pelo participante por meio
          do CALM, a qualquer momento, devendo o participante permanecer no
          programa escolhido.
        </p>

        <p>
          Ao solicitar a mudança de modalidade, o participante poderá utilizar
          os pontos acumulados na modalidade anterior, conforme a data de
          expiração ou até o momento em que forem esgotados.
        </p>

        <p>
          Após a alteração, o acúmulo de pontos observará as regras da nova
          modalidade, renunciando a todos os benefícios atrelados ao programa de
          relacionamento anterior, que serão prontamente cancelados e
          indisponibilizados pela LEROY MERLIN, passando a ter direito às
          condições e benefícios estabelecidos apenas no novo programa
          escolhido.
        </p>

        <p style={{ marginTop: 15 }}>
          <strong>Exceção:</strong> categoria PRO, em que é necessário consultar
          um Colaborador nas lojas físicas.
        </p>
      </S.RowTextBottom>
    </S.Wrapper>
  </S.Container>
)

export default OptIn
